import type { SvgType } from './types'

export default function Clock({ fill, style, size, viewBox }: SvgType) {
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      style={style}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <circle cx="12" cy="12" r="9" stroke={fill} strokeWidth="2" />
      <path
        d="M12 6.5L12 13L15.5 15"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
